import React from "react";
import { MyMenu } from "../Menu";
import { Footer } from "../Footer";
import { Helmet } from "react-helmet";
import "./style.scss";
import Text from "../ToggleText";
import { browserCheck } from "@ta-interaktiv/browsercheck";
// import CoverTwo from "../coverTwo";

export class Angebot extends React.Component {
  render() {
    return (
      <div className="App">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Angebot | Physiotherapie & Craniosacral Therapie Winterthur | PhysioWerk Schmitt</title>
          <meta
            name="description"
            content="Physiotherapie, Craniosacral Therapie, Massage – Wir bieten Ihnen ein umfassendes Therapieangebot in Winterthur Neuhegi. Krankenkassen anerkannt."
          />
          <html lang="de" amp />
          <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "Brauche ich eine Arztverordnung für Physiotherapie?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Ja, für die Kostenübernahme durch die Grundversicherung (KVG) benötigen Sie eine ärztliche Verordnung. Ohne Verordnung können Sie Physiotherapie auch auf eigene Kosten in Anspruch nehmen."
                }
              },
              {
                "@type": "Question",
                "name": "Wird Physiotherapie von der Krankenkasse bezahlt?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Physiotherapie auf ärztliche Verordnung wird von der Grundversicherung und der Unfallversicherung/IV übernommen. Craniosacral Therapie und Massage werden von den meisten Zusatzversicherungen anerkannt."
                }
              },
              {
                "@type": "Question",
                "name": "Was kostet eine Physiotherapie-Sitzung in Winterthur?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Ohne ärztliche Verordnung kostet eine Physiotherapie-Sitzung CHF 65.– (30 min) oder CHF 130.– (60 min). Mit Verordnung übernimmt die Krankenkasse die Kosten."
                }
              },
              {
                "@type": "Question",
                "name": "Wie lange dauert eine Behandlung bei PhysioWerk Schmitt?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Eine Behandlung dauert in der Regel 30 bis 60 Minuten. Beim ersten Termin nehmen wir uns zusätzlich Zeit für einen ausführlichen Befund."
                }
              },
              {
                "@type": "Question",
                "name": "Wo befindet sich die Physiotherapie-Praxis in Winterthur?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "PhysioWerk Schmitt befindet sich an der Else-Züblin-Strasse 115 in Winterthur Neuhegi (8404 Winterthur), direkt am Eulachpark. Die Praxis ist mit Bus und Bahn gut erreichbar und rollstuhlgängig."
                }
              }
            ]
          })}</script>
        </Helmet>
        <header className="App-header">
          <MyMenu />

          {/* <CoverTwo
            title="Vielfältige Therapie&shy;möglichkeiten"
            subtitle="Im ersten Termin entscheiden wir gemeinsam, welche Therapieform die optimale ist, um Sie
						näher an Ihr Ziel zu bringen."
          /> */}
        </header>
        <div
          className="ui vertical fitted segment"
          style={{ paddingTop: "calc(1.5vw + 1.5em)" }}
        >
          <div className="section">
            <div className="ui text container">
              <h2 className="center">Angebot</h2>
              <p>
                Ein Team von Physiotherapeuten bietet Ihnen ein breites Spektrum
                an therapeutischen und medizinischen Dienstleistungen an. Im
                ersten Termin entscheiden wir gemeinsam, welche Therapieform die
                optimale ist, um Sie näher an Ihr Ziel zu bringen. Anhand eines
                physiotherapeutischen Befundes evaluieren wir das Hauptproblem
                sowie mögliche begleitende und unterhaltende Faktoren und
                stellen so einen individuellen Behandlungsplan zusammen. Wir
                motivieren und unterstützen Sie in Ihrem Heilungsprozess aktiv.
              </p>
              {/* <div className='wrapperHighlight'>
                  <img
                    src={require("../imgs/icon-kompetenzen-solo.svg")}
                    className="ui image fluid icon benefit"
                    alt="Icon Kompetenzen"
                  /> */}
              <p className="legendIntro">
                Unsere Therapeuten sind{" "}
                <b className="bold violet">zertifizierte Fachkräfte</b> und
                somit bei den{" "}
                <b className="bold violet">
                  Krankenkassen und den meisten Zusatzversicherungen anerkannt
                </b>
                .
              </p>
              {/* </div> */}
            </div>
          </div>

          <div className="section">
            <div className="ui container">
              <div className="legendWrapper">
                <div className="legendEntryContainer">
                  <div>
                    <img
                      className="icon grundversicherung"
                      src={require("../imgs/icon-grundversicherung-blau.svg")}
                      alt="Check Grundversicherung"
                    ></img>
                    Grundversicherung
                  </div>
                  <div>
                    <img
                      className="Icon Zusatz"
                      src={require("../imgs/icon-zusatzversicherung-blau.svg")}
                      alt="Check Zusatzversicherung"
                    ></img>
                    {browserCheck.isMobile
                      ? "Zusatzvers."
                      : "Zusatzversicherung"}
                  </div>
                </div>
              </div>
              <div className="ui relaxed grid stackable">
                <div className="sixteen wide mobile eight wide tablet eight wide computer column service">
                  <div className="productHeader">
                    <div className="iconWrapper">
                      <div>
                        <img
                          className="icon grundversicherung"
                          src={require("../imgs/icon-grundversicherung.svg")}
                          alt="Check Grundversicherung"
                        ></img>
                      </div>
                    </div>

                    <img
                      src={
                        browserCheck.isMobile
                          ? require("../imgs/physiotherapie-mobile.jpg")
                          : require("../imgs/physiotherapie-desktop.jpg")
                      }
                      className="ui image fluid icon"
                      alt="Thumbnail Physiotherapie"
                    ></img>

                    {/* <div className='teaserTitleWrapper'>
                  <h3>Physiotherapie</h3>
                  <span>Krankenkassen anerkannt</span>
                </div> */}
                  </div>

                  <Text
                    title="Physiotherapie"
                    shortText={
                      "<p>Physiotherapie ist die Kombination von passiven und aktiven Massnahmen/Techniken um die Bewegungs- und Funktionsfähigkeit des menschlichen Körpers wiederherzustellen, zu verbessern oder zu erhalten. Dies findet Anwendung in der Rehabilitation, sowie in der Prävention von Krankheiten und Unfällen.</p>"
                    }
                    longText={
                      "<br /><p class='thin'>Das Ziel ist die Wiederherstellung, Erhaltung oder Förderung der Gesundheit, dies geht sehr häufig mit der Schmerzfreiheit bzw. -reduktion einher. Physiotherapeuten beraten dementsprechend die Patienten individuell und instruieren ihnen auch ein Heimprogramm.<div class='tarifbox'><div class='rowBox'><p class='tarifTitle'>Tarife</p><p class='tarifDescription'>Auf ärztliche Verordnung wird die Physiotherapie von der Grundversicherung oder Unfallversicherung/IV bezahlt.</p></div><div class='rowBox'><h4 class='tarifTitle'>Ohne Verordnung</h4><table class='tarifbox fiftyWide' style='width: 100%'><tr><th></th><th>1 Sitzung</th></tr><tr><td>30&nbsp;min</td><td>CHF&nbsp;65.–</td></tr><tr><td>60&nbsp;min</td><td>CHF&nbsp;130.–</td></tr></table><p class='timeNote'>Angabe ist in Bruttozeit, wir verwenden jeweils 5 Minuten zur Vor- und Nachbearbeitung.</p></div></div><p class='bold'>Behandlungsfelder:</p><ul class='thin'><li>Orthopädie</li><li>Chirurgie</li><li>Neurologie</li><li>Innere Medizin</li><li>Pädiatrie (ab 5 Jahren)</li><li>Geriatrie</li><li>Rheumatologie</li><li>Sportverletzungen</li><li>Rehabilitation</li><li>Prävention</li><li>Hausbesuche (Domizilbehandlung)</li></p></ul>"
                    }
                  />
                </div>

                <div className="sixteen wide mobile eight wide tablet eight wide computer column service">
                  <div className="productHeader">
                    <div className="iconWrapper">
                      <div>
                        <img
                          className="icon zusatz"
                          src={require("../imgs/icon-zusatzversicherung.svg")}
                          alt="Check Zusatzversicherung"
                        ></img>
                      </div>
                    </div>
                    <img
                      src={
                        browserCheck.isMobile
                          ? require("../imgs/craniosacraltherapie-mobile.jpg")
                          : require("../imgs/craniosacral-desktop.jpg")
                      }
                      className="ui image fluid icon"
                      alt="Thumbnail Craniosacral Therapie"
                    />
                  </div>
                  <Text
                    title="Craniosacral Therapie"
                    shortText={
                      "<p>Die Cranio-Sacral-Therapie (vom Lateinischen cranium: Schädel; sacral: das Kreuzbein) ist eine ganzheitliche Methode der Alternativmedizin, die sich aus der Osteopathie entwickelt hat. Die Grundlage davon ist die rhythmische Pulsation der Gehirn-Rückenmarksflüssigkeit (Liquor cerebrospinalis), der sogenannte primär respiratorische Mechanismus (PRM), welcher sich auf den Körper überträgt und dort wahrgenommen werden kann.</p>"
                    }
                    longText={
                      "<br /><p class='thin'>Durch Unfälle, Krankheiten, Traumata etc. wird dieser Rhythmus im Körper gestört und Blockaden können entstehen, welche sich auf das körperliche und seelische Wohlbefinden des Menschen auswirken. Die Craniosacral Therapeuten nehmen Blockaden oder disharmonische Bewegungen im Körper wahr, unterstützen diese mit feinen manuellen Impulsen, welche die Selbstregulierungskräfte des Körpers aktivieren, und begleiten die Klienten auf dem Weg zur Selbstheilung.</p><div class='tarifbox'><div class='rowBox'><p class='tarifTitle'>Tarife</p><p class='tarifDescription'>Die Behandlung ohne ärztliche Verordnung wird von den meisten Zusatzversicherungen (über die Komplementärversicherung) teilweise oder ganz vergütet. Erkundigen Sie sich diesbezüglich vor Beginn der Therapie bei Ihrer Krankenkasse. Wir sind beim EMR registriert und somit von den meisten Kranken-Zusatzversicherungen anerkannt.</p></div><div class='rowBox'><h4 class='tarifTitle'>Selbstzahler</h4><table class='tarifbox fiftyWide' style='width: 100%'><tr><th></th><th>1 Sitzung</th></tr><tr><td>60&nbsp;min</td><td>CHF&nbsp;132.–</td></tr></table></div></div><p class='bold'>Anwendungsbereiche:</p><ul class='thin'><li>Unterstützung in belastenden Lebenssituationen</li><li>Rehabilitation nach Krankheit oder Unfall</li><li>Schleuder-, Sturz- und Stauchtrauma</li><li>Regulation für den Bewegungsapparat, die Organe, das Lymphsystem, das Hormonsystem, das vegetative und zentrale Nervensystem</li><li>Schlafprobleme, Erschöpfungszustände, Depressionen</li><li>stressbedingte Beschwerden, Burnout-Syndrom</li><li>Störungen des Immunsystems</li><li>Hyperaktivität von Kindern, Konzentrationsstörungen und Lernschwierigkeiten</li><li>Gynäkologische Indikationen: Menstruationsbeschwerden, Schwangerschafts- und Geburtsbegleitung, organische und emotionale Unterstützung in der Schwangerschaft und zur Vorbereitung auf die Geburt, Rückenschmerzen, Optimierung der Beckenfunktion (Beweglichkeit des Beckens und des Kreuzbeins) für die Geburt, Nachbetreuung der Mutter nach der Geburt oder Problemgeburt (Zangengeburt, Saugglocke, Kaiserschnitt usw.)</ul>"
                    }
                  />
                </div>

                <div className="sixteen wide mobile eight wide tablet eight wide computer column service">
                  <div className="productHeader">
                    <div className="iconWrapper">
                      <div>
                        <img
                          className="icon grundversicherung"
                          src={require("../imgs/icon-grundversicherung.svg")}
                          alt="Check Grundversicherung"
                        ></img>
                      </div>
                    </div>
                    <img
                      src={
                        browserCheck.isMobile
                          ? require("../imgs/funktionelles-training-mobile.jpg")
                          : require("../imgs/funktionelles-training-desktop.jpg")
                      }
                      className="ui image fluid icon"
                      alt="Thumbnail Funktionelles Training"
                    />
                  </div>
                  <Text
                    title="Funktionelles Training"
                    shortText={
                      "<p>Diese Trainingsform wird nicht nur in der Rehabilitation von Patienten angewandt, sondern kann auch zur Verletzungsprävention und Verbesserung der Athletik im Leistungssport genutzt werden. Richtig angewandt, können Personen aller Altersklassen und Leistungsniveaus vom funktionellen Training profitieren. Das Ziel ist individuell auf den Klienten abgestimmt und sein Fortschritt wird regelmässig kontrolliert.</p>"
                    }
                    longText={
                      "<br /><p class='thin'>Funktionelles Training besteht überwiegend aus Übungen, bei denen mit dem eigenen Körpergewicht als Widerstand gearbeitet wird. Durch die Übung selbst, durch instabile oder labile Unterlagen oder durch einen äusseren Reiz (z. B. Trainer) wird eine instabile Gleichgewichtssituation hervorgerufen, in welcher sich der Klient stabilisieren beziehungsweise ausbalancieren muss. Dabei werden vor allem Übungen ausgewählt, die mehrere Gelenke und Muskelgruppen gleichzeitig ansprechen, da es im Alltag so gut wie keine Bewegungen gibt, die nur ein Gelenk oder nur einen Muskel erfordern. Somit steht es im Gegensatz zum traditionellen Krafttraining, bei dem oft ein Grossteil der Übungen an Geräten absolviert wird, um die anzusprechenden Muskeln oder Muskelgruppen gezielt zu isolieren.</p><p class='thin'>Die Übungsauswahl sollte Kraft, Schnellkraft, Balance, Stabilität, Flexibilität und Ausdauer verbessern, sowie die Koordination und Ökonomisierung von Bewegungen. Von hoher Bedeutung in allen Sportarten ist die Propriozeption (Eigenwahrnehmung von Muskeln, Sehnen und Gelenken) und speziell die Stabilisation von Gelenken und dem gesamten Rumpf (Core Stability). Es wird viel im Stehen, in Stützpositionen und mit Lauf-, Sprung- und Drehbewegungen gearbeitet.</p><p class='thin'>Auch das Olympische Gewichtheben, sowie Turnelemente (Klimmzüge, Handstand, Muscle ups etc.), Plyometrics (z.B. Boxsprünge) und Strongman-Elemente gehören mit dazu. Funktionelles Training beinhaltet im Workout auch das Training mit Slingtrainer wie TRX Suspension Training und weitere Trainingsgeräte wie z.B. das Slidingboard, das Sypoba, die Monkey Bars usw.</p><div class='tarifbox'><div class='rowBox'><p class='tarifTitle'>Tarife</p><p class='tarifDescription'>Das funktionelle Training ist eine Methode in der Physiotherapie. Mit einer Verordnung für Physiotherapie wird das funktionelle Training von der Grundversicherung oder Unfallversicherung/IV bezahlt.</p></div><div class='rowBox'><h4 class='tarifTitle'>Ohne Verordnung</h4><table class='tarifbox fiftyWide' style='width: 100%'><tr><th></th><th>1 Sitzung</th></tr><tr><td>30&nbsp;min</td><td>CHF&nbsp;65.–</td></tr><tr><td>60&nbsp;min</td><td>CHF&nbsp;130.–</td></tr></table><p class='timeNote'>Angabe ist in Bruttozeit, wir verwenden jeweils 5 Minuten zur Vor- und Nachbearbeitung.</p></div></div>"
                    }
                  />
                </div>

                <div className="sixteen wide mobile eight wide tablet eight wide computer column service">
                  <div className="productHeader">
                    <div className="iconWrapper">
                      <div>
                        <img
                          className="icon grundversicherung"
                          src={require("../imgs/icon-grundversicherung.svg")}
                          alt="Check Grundversicherung"
                        ></img>
                        <img
                          className="icon zusatz"
                          src={require("../imgs/icon-zusatzversicherung.svg")}
                          alt="Check Zusatzversicherung"
                        ></img>
                      </div>
                    </div>
                    <img
                      src={
                        browserCheck.isMobile
                          ? require("../imgs/manuelle-lymphdrainage-mobile.jpg")
                          : require("../imgs/manuelle-lymphdrainage-desktop.jpg")
                      }
                      className="ui image fluid icon"
                      alt="Thumbnail Manuelle Lymphdrainage"
                    />
                  </div>
                  <Text
                    title="Manuelle Lymphdrainage"
                    shortText={
                      "<p>Bei geschwollenen und schweren Beinen hilft die Lymphdrainage. Sie unterstützt den Körper dabei, die überschüssige Flüssigkeit und andere Abfallstoffe abzutransportieren, sie bringt Linderung und gleichzeitig eine Entschlackung.</p>"
                    }
                    longText={
                      "<br /><p class='thin'>Unter manueller Lymphdrainage versteht man die Aktivierung des Lymphabflusses bzw. die Entstauung (Drainage) des Gewebes mittels manueller (vom Therapeuten per Hand) durchgeführten Techniken (manuelle Lymphdrainage) in Verbindung mit einem Kompressionsverband. Das ödematöse Gewebe kann nach Krankheiten, Traumata oder Operationen entstehen. Besonders häufig wird diese Therapie nach einer Tumorbehandlung bzw. Lymphknotenentfernung angewandt.</p><p class='thin'>Weitere Indikationen sind sämtliche orthopädischen und traumatologischen Erkrankungen, die mit einer Schwellung einhergehen (z. B. Verrenkungen, Zerrungen, Verstauchungen, Muskelfaserrisse), sowie bei Verbrennungen, Schleudertrauma, Morbus Sudeck, Migräne und ähnlichen Krankheitsbildern.</p><div class='tarifbox'><div class='rowBox'><h4 class='tarifTitle'>Tarife</h4><p class='tarifDescription'>Auf ärztliche Verordnung wird die manuelle Lymphdrainage von der Grundversicherung oder Unfallversicherung/IV bezahlt.</p></div><div class='rowBox'><h4 class='tarifTitle'>Selbstzahler</h4><table class='tarifbox' style='width: 100%'><tr><th></th><th>1 Sitzung</th><th>5er&#8209;Abo</th></tr><tr><td>30&nbsp;min</td><td>CHF&nbsp;65.–</td><td>CHF&nbsp;309.–</td></tr><tr><td>60 min</td><td>CHF&nbsp;130.–</td><td>CHF&nbsp;617.–</td></tr></table><p class='timeNote'>Angabe ist in Bruttozeit, wir verwenden jeweils 5 Minuten zur Vor- und Nachbearbeitung.</p></div></div>"
                    }
                  />
                </div>

                <div className="sixteen wide mobile eight wide tablet eight wide computer column service">
                  <div className="productHeader">
                    <div className="iconWrapper">
                      <div>
                        {/* <img
                          className="icon zusatz"
                          src={require("../imgs/icon-zusatzversicherung.svg")}
                          alt="Check Zusatzversicherung"
                        ></img> */}
                      </div>
                    </div>
                    <img
                      src={
                        browserCheck.isMobile
                          ? require("../imgs/klassische-massage-mobile.jpg")
                          : require("../imgs/klassische-massage-desktop.jpg")
                      }
                      className="ui image fluid icon"
                      alt="Thumbnail Massage"
                    />
                  </div>
                  <Text
                    title="Massage"
                    label="<span class='ui horizontal label violet'>Neu</span>"
                    shortText={
                      "<p>Ein verspannter Nacken, schmerzender Rücken, stressiger Alltag? Da ist eine Massage genau das Richtige. Zeit für sich nehmen, sich entspannen und verwöhnen lassen: genau das können sie bei uns in einer Massage.</p>"
                    }
                    longText={
                      "<br /><p class='thin'>Bei der Massage werden Haut, Unterhaut, Muskeln und tiefer gelegenes Gewebe mit den Händen oder speziellen Gerätschaften bearbeitet. Massagen gelten als eines der ältesten Heilmittel. Sie entspannen und vitalisieren, lockern verspannte Muskulatur, fördern die Durchblutung und den Lymphstrom, kurbeln den Stoffwechsel an, regen die Bildung von Gelenkflüssigkeit an, aktivieren unsere Selbstheilungskräfte. Kurzum: Sie tun gut und machen uns glücklich.</p><div class='tarifbox'><div class='rowBox'><h4 class='tarifTitle'>Arten</h4><p class='tarifDescription'>Klassische Massage, Sportmassage, Entspannungsmassage, Ganzkörpermassage, Teilmassage, Fussreflexzonenmassage, HotStone Massage, Aromaölmassage.</p></div><div class='rowBox'><h4 class='tarifTitle'>Selbstzahler</h4><table class='tarifbox' style='width: 100%'><tr><th></th><th>1 Sitzung</th><th>5er&#8209;Abo</th></tr><tr><td>30&nbsp;min</td><td>CHF&nbsp;65.–</td><td>CHF&nbsp;309.–</td></tr><tr><td>60 min</td><td>CHF&nbsp;130.–</td><td>CHF&nbsp;617.–</td></tr><tr><td>90 min</td><td>CHF&nbsp;195.–</td><td>CHF&nbsp;926.–</td></tr></table><p class='timeNote'>Angabe ist in Bruttozeit, wir verwenden jeweils 5 Minuten zur Vor- und Nachbearbeitung.</p></div></div>"
                    }
                  />
                </div>

                <div className="sixteen wide mobile eight wide tablet eight wide computer column service">
                  <div className="productHeader">
                    <div className="iconWrapper">
                      <div>
                        <img
                          className="icon grundversicherung"
                          src={require("../imgs/icon-grundversicherung.svg")}
                          alt="Check Grundversicherung"
                        ></img>
                      </div>
                    </div>
                    <img
                      src={
                        browserCheck.isMobile
                          ? require("../imgs/schwangerschaft-mobile.jpg")
                          : require("../imgs/schwangerschaft-desktop.jpg")
                      }
                      className="ui image fluid icon"
                      alt="Thumbnail Physiotherapie für Schwangere und junge Mütter"
                    />
                    {/* <div className='teaserTitleWrapper'>
                    <h3>Schwangerschaft</h3>
                    <span>gezieltes Training vor und nach der Geburt</span>
                  </div> */}
                  </div>
                  <Text
                    title="Physiotherapie für Schwangere und junge&#160;Mütter"
                    shortText={
                      "<p>Rückenschmerzen, geschwollenen Beine, Nackenverspannungen oder Probleme mit dem Beckenboden sind häufige Beschwerden, die im Zusammenhang mit einer Schwangerschaft auftreten. Eine physiotherapeutische Behandlung kann Linderung verschaffen.</p>"
                    }
                    longText={
                      "<br /><p class='thin'>Eine der besten Möglichkeiten, um eine <b>angenehme Schwangerschaft</b> zu erleben und Komplikationen zu verringern/vermeiden, ist es, die Schwangerschaft physiotherapeutisch zu begleiten. Hier sind einige der wichtigsten Vorteile und Stärken dieser Therapieform:<br><ul class='thin'><li><b>Linderung von Schmerzen und Beschwerden:</b> Eine Schwangerschaft bringt viele körperliche Veränderungen mit sich, die zu Schmerzen und Beschwerden an Rücken, Unterbauch, Becken, Gesäss, Hüfte und Beinen führen können. Physiotherapie kann helfen, diese Beschwerden zu lindern und zu verhindern, dass sie schlimmer werden.</li><li><b>Verbesserung der Körperhaltung:</b> Die zunehmende Grösse des Bauches verursacht Veränderungen der Körperhaltung. Eine schlechte Körperhaltung kann zu vielen Schwierigkeiten führen, einschliesslich Schmerzen und Beschwerden. Physiotherapie in der Schwangerschaft kann helfen, die Körperhaltung zu verbessern und Veränderungen auszugleichen.</li><li><b>Stärkung der Beckenbodenmuskulatur:</b> Eine starke Beckenbodenmuskulatur ist wichtig für eine angenehme Schwangerschaft und eine erfolgreiche Geburt. Physiotherapie in der Schwangerschaft kann helfen, diese Muskeln zu stärken und Verletzungen sowie Inkontinenz oder eine Senkung der Beckenorgane zu verringern/vermeiden.</li><li><b>Vermeidung von Komplikationen:</b> Physiotherapie kann helfen, potenzielle Komplikationen wie vorzeitige Wehen, Beckenendlage oder eine gestörte Durchblutung zu verringern/vermeiden.</li><li><b>Vorbereitung auf die Geburt:</b> Physiotherapie in der Schwangerschaft kann auch helfen, die Frau auf die Geburt vorzubereiten, indem sie sie über den Geburtsprozess informiert und ihr Übungen zur Vorbereitung auf die Geburt zeigt.</li></p></ul><p class='thin'><b>Nach der Geburt</b> möchten viele Mütter ihren Körper zurück. Während das Kind im Mutterleib wächst, werden die Bauchmuskeln gedehnt, der Beckenboden belastet und die Statik des Körpers verändert sich. Wir legen besonderen Wert auf eine gute Rückbildung, um einer möglichen Inkontinenz, schlechter Haltung (besonders bei stillenden Müttern) oder muskulären Verspannungen frühzeitig entgegenzuwirken.</p><div class='tarifbox'><div class='rowBox'><p class='tarifTitle'>Tarife</p><p class='tarifDescription'>Fragen Sie Ihren Gynäkologen oder Hausarzt nach einer Verordnung für eine solche Physiotherapie, denn im Rahmen einer Schwangerschaft werden die Kosten zu 100% von Ihrer Krankenkasse übernommen.</p></div><div class='rowBox'><h4 class='tarifTitle'>Ohne Verordnung</h4><table class='tarifbox fiftyWide' style='width: 100%'><tr><th></th><th>1 Sitzung</th></tr><tr><td>30&nbsp;min</td><td>CHF&nbsp;65.–</td></tr><tr><td>60&nbsp;min</td><td>CHF&nbsp;130.–</td></tr></table><p class='timeNote'>Angabe ist in Bruttozeit, wir verwenden jeweils 5 Minuten zur Vor- und Nachbearbeitung.</p></div></div>"
                    }
                  />
                </div>

                {/* <div className="sixteen wide mobile eight wide tablet eight wide computer column service">
                  <div className="productHeader">
                    <div className="iconWrapper">
                      <div>
                        <img
                          className="icon zusatz"
                          src={require("../imgs/icon-zusatzversicherung.svg")}
                          alt="Check Zusatzversicherung"
                        ></img>
                      </div>
                    </div>
                    <img
                      src={
                        browserCheck.isMobile
                          ? require("../imgs/naturheilkunde-mobile.jpg")
                          : require("../imgs/naturheilkunde-desktop.jpg")
                      }
                      className="ui image fluid icon"
                      alt="Thumbnail Naturheilkunde"
                    />
                  </div>
                  <Text
                    title="Naturheilkunde"
                    label="<span class='ui horizontal label violet'>Neu</span>"
                    shortText={
                      "<p>Die traditionell europäische Naturheilkunde TEN bietet viele verschiedene Therapiemöglichkeiten, welche individuell angewendet und kombiniert werden können. Welche Methode zielführend und typgerecht ist, wird über eine ausführliche Anamnese und Diagnostik eruiert. Die Therapie behandelt demnach nicht nur die offensichtlichen Symptome, sondern versucht auch die auslösenden Faktoren zu berücksichtigen. So kann eine langfristige, stabile Gesundheit angestrebt werden.</p>"
                    }
                    longText={
                      "<br /><p class='thin'><b>Phytotherapie (Pflanzenheilkunde)</b><br>Die Pflanzenheilkunde setzt Pflanzen gezielt zur Behandlung von körperlichen und psychischen Belastungen und Symptomen ein. Es wird dabei grossen Wert auf die Konstitution des Patienten und die individuelle Empfindung der Beschwerden gelegt. Die Heilpflanzen unterstützen uns mit ihren sehr komplexen Inhaltsstoffgemischen wie auch mit ihren ganz eigenen Wachstumseigenschaften und ihrem Wesen. Wir streben die Aktivierung der Selbstheilungskräfte an.<br><p class='thin'>Die Phytotherapie kann sehr vielseitig als Urtinktur, Tinktur, Tee, Spagyrik- wie auch als Gemmo-Spray innerlich oder äusserlich als Auflage, Salbe oder Bad angewendet werden. Sie ersetzt in bestimmten Fällen keine schulmedizinische Behandlung, kann da aber begleitend und unterstützend eingesetzt werden.</p><p class='thin'><b>Ernährungsberatung</b><br>Nahrung ermöglicht uns die Aufrechterhaltung aller Körperfunktionen und versorgt uns mit den lebensnotwendigen Nährstoffen. Essen bedeutet noch viel mehr, zum Beispiel Genuss und Freude, führt aber zum Teil auch zu leidvollen Reaktionen und krankmachenden Störungen. Nahrung zu verdauen benötigt viel Energie und eine feine Abstimmung verschiedenster physiologischer Vorgänge im Körper. Fehl- oder Mangelernährung, Allergien oder Stress können unser Essverhalten negativ beeinflussen, was zu massiven körperlichen Beschwerden führen kann.</p><p class='thin'>Das Angebot der Ernährungsberatung bietet eine bewusste Auseinandersetzung mit dem eigenen Essverhalten, zeigt Möglichkeiten für eine ausgewogene, alltagstaugliche Ernährung auf und begleitet hin zu einem gesunden und nachhaltigen Lebensstil.</p><p class='thin'>Naturheilkundliches Angebot:</p><ul class='thin'><li><b>Klassische Massage</b><br>Krankenkassen anerkannt (Zusatzversicherung)</li><li><b>Fussreflexzonen Therapie</b><br>Krankenkassen anerkannt (Zusatzversicherung)</li><li><b>Schröpfen, Baunscheidtieren, Hydrotherapie</b><br>Krankenkassen anerkannt (Zusatzversicherung)</li><li><b>Phytotherapie / Pflanzenheilkunde</b></li><li><b>Ernährungsberatung / Ordnungstherapie</b></li><li><b>Diagnostik (Iris, Zunge, Puls)</b></li><li><b>Konstitutionstherapie</b></li></ul><div class='tarifbox'><div class='rowBox'><p class='tarifTitle'>Tarife</p><p class='tarifDescription'>Die Sitzung ist zum reduzierten Preis, da sich Leana noch in der Ausbildung befindet. Ab Mai 2025 ist Leana als Naturheilpraktikerin beim EMR registriert und somit von den meisten Kranken-Zusatzversicherungen anerkannt.</p></div><div class='rowBox'><h4 class='tarifTitle'>Selbstzahler</h4><table class='tarifbox fiftyWide' style='width: 100%'><tr><th></th><th>1 Sitzung</th></tr><tr><td>45&nbsp;min</td><td>CHF&nbsp;90.–</td></tr><tr><td>60&nbsp;min</td><td>CHF&nbsp;120.–</td></tr><tr><td>75&nbsp;min</td><td>CHF&nbsp;150.–</td></tr></table><p class='timeNote'>Angabe ist in Bruttozeit, wir verwenden jeweils 5 Minuten zur Vor- und Nachbearbeitung.</p></div></div><p class='thin'><p class='bold'>Anwendungsbereiche:</p><p class='thin'><b>Phytotherapie</b><br>chron. Infekte, psych. Belastungen, Allergien, Hauterkrankungen, Verdauungsbeschwerden, Migräne, Frauenbeschwerden (Menstruationsbeschwerden, PMS, Endometriose, Fertilitätsstörungen), Verbesserung des Wohlbefindens, Steigerung der Leistungs- und Konzentrationsfähigkeit.</p><p class='thin'><b>Ernährungsberatung</b><br>Verdauungsbeschwerden, Allergien, Übergewicht / Adipositas, Mangelerscheinungen, Verbesserung des Wohlbefindens, Steigerung der Leistungs- und Konzentrationsfähigkeit.</p>"
                    }
                  />
                </div> */}
              </div>
            </div>
          </div>

          <div className="section">
            <div className="ui container">
              <h2 className="center">weitere therapeutische Methoden</h2>
              <div className="ui equal width relaxed grid stackable Two">
                <div className="column dl">
                  <ul className="no-bullets">
                    <li>
                      <i className="icon check"></i>Haltungs- und
                      Bewegungstherapie
                    </li>
                    <li>
                      <i className="icon check"></i>Manuelle Therapie (nach
                      Maitland, Kaltenborn-Evjenth, Ganeo)
                    </li>
                    <li>
                      <i className="icon check"></i>Spinaltherapie nach Mc
                      Kenzie
                    </li>
                    <li>
                      <i className="icon check"></i>Propriozeptive
                      Neuromuskuläre Fazilitation (PNF)
                    </li>
                    <li>
                      <i className="icon check"></i>Medizinische Rehabilitation
                      und individuelle Trainingstherapie
                    </li>
                    <li>
                      <i className="icon check"></i>Neurologische Behandlungen
                      für Kinder (ab 5. LJ.) und Erwachsene
                    </li>
                    <li>
                      <i className="icon check"></i>Manuelle Lymphdrainage und
                      Kompressionstherapie
                    </li>
                    <li>
                      <i className="icon check"></i>Narbentherapie
                    </li>
                    <li>
                      <i className="icon check"></i>Behandlung von Schwindel und
                      Gleichgewichtsproblemen
                    </li>
                    <li>
                      <i className="icon check"></i>Triggerpunkttherapie
                    </li>
                  </ul>
                </div>
                <div className="column dl">
                  <ul className="no-bullets">
                    <li>
                      <i className="icon check"></i>Schröpfen
                    </li>
                    <li>
                      <i className="icon check"></i>Elektrotherapie
                    </li>
                    <li>
                      <i className="icon check"></i>Ultraschalltherapie
                    </li>
                    <li>
                      <i className="icon check"></i>Thermotherapie
                    </li>
                    <li>
                      <i className="icon check"></i>Beckenbodenrehabilitation,
                      speziell nach der Geburt
                    </li>
                    <li>
                      <i className="icon check"></i>Atemtherapie
                    </li>
                    <li>
                      <i className="icon check"></i>Entspannungstherapie
                    </li>
                    <li>
                      <i className="icon check"></i>Faszienbehandlung
                    </li>
                    <li>
                      <i className="icon check"></i>Kinesio-Taping
                    </li>
                    <li>
                      <i className="icon check"></i>Hausbesuche
                      (Domizilbehandlung)
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="section">
            <div className="ui container">
              <p className="hinweis">
                <span className="bold">Absagen und Umbuchungen:</span>
                <br />
                Wir bitte Sie Termine, welche Sie nicht zur vereinbarten Zeit
                wahrnehmen können, mindestens 24 Stunden vorher umzubuchen oder
                abzusagen. Für die vereinbarten Sitzungen reservieren wir die
                Zeit für Sie und muss Ihnen daher die Kosten für kurzfristig
                abgesagte und verpasste Termine in Rechnung stellen.
              </p>
            </div>
          </div>

          <div className="section">
            <div className="ui text container">
              <h2 className="center">Naturheilkunde</h2>
              <p>
                Leana hat den Schritt in die Selbständigkeit gewagt und bietet
                mit Leana natura – Naturheilkunde und Alternativmedizin – in den
                Räumlichkeiten unserer Gesundheitspraxis Physiowerk Schmitt an.
              </p>
              <br />
            </div>
            <div className="ui container">
              <div className="ui grid relaxed stackable">
                <div className="two column row">
                  <div className="six wide column">
                    <div className="imageWrapper">
                      <img
                        src={require("../imgs/leana-baechtold-leana-natura.jpg")}
                        alt="Porträt Leana Bächtold"
                        className="ui centered image round"
                      />
                    </div>
                    <h2 className="name">Leana Bächtold</h2>
                    <h3 className="jobtitle">
                      Naturheilpraktikerin TEN, Berufsmasseurin, Yogalehrerin
                    </h3>
                  </div>
                  <div className="ten wide column">
                    <p>
                      Der Mensch als ganzheitliches Wesen steht für mich im
                      Zentrum jeder Behandlung. Als Naturheilpraktikerin und
                      Alternativmedizinerin kombiniere ich sowohl
                      schulmedizinisches Wissen, wie auch jenes der
                      jahrhundertealten Heilkunde. Ich nutze dabei die Kräfte
                      der Natur in Form der Pflanzenheilkunde,
                      Ernährungsberatung oder Massageanwendungen mit Feuer,
                      Wasser, Ölen oder Auflagen.
                    </p>
                    <p>
                      Angebot: Naturheilkunde, Pflanzenheilkunde, verschiedene
                      Massagetechniken, Ernährungsberatung, Ausleitende
                      Verfahren (Schröpfen, Baunscheidtieren)
                    </p>
                    {/* <div class="tarifbox">
                      <div class="rowBox">
                        <p class="tarifTitle">Tarife</p>
                        <p class="tarifDescription">
                          Leana als Naturheilpraktikerin beim EMR registriert
                          und somit von den meisten Kranken-Zusatzversicherungen
                          anerkannt.
                        </p>
                      </div>
                      <div class="rowBox">
                        <h4 class="tarifTitle">Selbstzahler</h4>
                        <table class="tarifbox fiftyWide" style={{width: "100%;"}}>
                          <tr>
                            <th></th>
                            <th>1 Sitzung</th>
                          </tr>
                          <tr>
                            <td>60&nbsp;min</td>
                            <td>CHF&nbsp;138.–</td>
                          </tr>
                        </table>
                        <p class="timeNote">
                          Angabe ist in Bruttozeit, ich verwende jeweils 5
                          Minuten zur Vor- und Nachbearbeitung.
                        </p>
                      </div>
                    </div>*/}
                    <a
                      href="https://www.leananatura.ch"
                      target="_blank"
                      className="externalLink"
                      rel="noopener noreferrer"
                    >
                      <div className="ui animated button" tabIndex="0">
                        <div className="visible content">Zur Webseite</div>

                        <div className="hidden content">
                          <i className="right arrow icon" />
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <Footer className="footer" />
        </div>
      </div>
    );
  }
}
